import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  distanceUnit: 'Mile', // Default value
  speedUnit: 'mph', // Default speed unit
};

const unitSlice = createSlice({
  name: 'unit',
  initialState,
  reducers: {
    setDistanceUnit: (state, action) => {
      state.distanceUnit = action.payload;
      // Update the speed unit whenever the distance unit changes
      if (action.payload === 'Furlong') {
        state.speedUnit = 's/f';
      } else if (action.payload === 'Mile') {
        state.speedUnit = 'mph';
      } else if (action.payload === 'Meter') {
        state.speedUnit = 'm/s';
      }
    },
  },
});

export const { setDistanceUnit } = unitSlice.actions;
export default unitSlice.reducer;
